export default {
  namespaced: true,
  state: {
    menuItems: [],
  },
  getters: {
    menuItems: (state) => state.menuItems,
  },
  mutations: {
    setMenuItems(state, items) {
      state.menuItems = items;
    },
  },
  actions: {
    async fetchMenu({ commit }) {
      try {
        const api = (await import("@/services/api")).default;
        const res = await api.get("/auth/menu");
        commit("setMenuItems", res.data || []);
      } catch {
        // silently fail
      }
    },
  },
};
